import { render, staticRenderFns } from "./Statistiche.vue?vue&type=template&id=49d4c1cd&scoped=true"
import script from "./Statistiche.vue?vue&type=script&lang=ts"
export * from "./Statistiche.vue?vue&type=script&lang=ts"
import style0 from "./Statistiche.vue?vue&type=style&index=0&id=49d4c1cd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4c1cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d4c1cd')) {
      api.createRecord('49d4c1cd', component.options)
    } else {
      api.reload('49d4c1cd', component.options)
    }
    module.hot.accept("./Statistiche.vue?vue&type=template&id=49d4c1cd&scoped=true", function () {
      api.rerender('49d4c1cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Statistiche.vue"
export default component.exports